import React, { useEffect } from "react";
import EmployeeCalendar from "./EmployeeCalendar";

interface RouteParams {
  employeeId: string;
}
interface RouteMatch {
  params: RouteParams;
}
interface Props {
  match: RouteMatch; // from router
};

const EmployeeCalendarRoute = ({
  match,
} : Props) => {

  const id = parseInt(match.params.employeeId);

  return (
    <div className="calendar-route-container">
      <EmployeeCalendar employeeId={id} />
    </div>
  )
};

export default EmployeeCalendarRoute;